import { TrendFrequency } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import { getOrgUseWeeklyEveryone } from '@fullstory/redux/modules/fullstory/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getDefaultTimeRange } from '../utils';

export const useDefaultTimeRange = (trendFrequency?: TrendFrequency) => {
  const isWeeklyTimeRange = useSelector(getOrgUseWeeklyEveryone);

  return useMemo(
    () => getDefaultTimeRange(isWeeklyTimeRange, trendFrequency),
    [isWeeklyTimeRange, trendFrequency],
  );
};
